import { createLucideIcon } from "lucide-react";

// Ghana cedi (₵) versions of lucide's money icons, same sizing/stroke API.
const cedi = (cx, cy, r) => [
  ["path", { d: `M${cx + r * 0.75} ${cy - r * 0.66}A${r} ${r} 0 1 0 ${cx + r * 0.75} ${cy + r * 0.66}`, key: "c" }],
  ["path", { d: `M${cx} ${cy - r * 1.45}v${r * 2.9}`, key: "l" }],
];

export const CediSign = createLucideIcon("CediSign", cedi(12, 12, 6.5));

export const ReceiptCedi = createLucideIcon("ReceiptCedi", [
  ["path", { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "r" }],
  ...cedi(12, 12, 3.6),
]);

export const BadgeCedi = createLucideIcon("BadgeCedi", [
  ["path", { d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z", key: "b" }],
  ...cedi(12, 12, 3.6),
]);
